/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import useBrand from 'wfui-digital-core/es/useBrand';
import useSettings from '../hooks/use-settings';
import StagecoachBackgroundImage from './StagecoachBackgroundImage';
import StagecoachBackgroundImageTPB from './StagecoachBackgroundImageTPB';

var StageCoach = function StageCoach() {
  var brand = useBrand();

  var _useSettings = useSettings(),
      useTPBBimUpdates = _useSettings.useTPBBimUpdates;

  return /*#__PURE__*/React.createElement(Block, {
    pt: "xl"
  }, 'tpb' === brand && useTPBBimUpdates ? /*#__PURE__*/React.createElement(StagecoachBackgroundImageTPB, null) : /*#__PURE__*/React.createElement(StagecoachBackgroundImage, null));
};

export default StageCoach;